export const APP_TITLE = 'Attendix'



// WEBPACK FOOTER //
// ./src/constants/customization.js